import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';

// Component Imports
import Button from 'primevue/button';
import Card from 'primevue/card';
import Carousel from 'primevue/carousel';
import InputText from 'primevue/inputtext';
import Textarea from 'primevue/textarea';
import Toolbar from 'primevue/toolbar';
import { Menubar } from 'primevue';

import 'primeicons/primeicons.css';

const app = createApp(App);

app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            // This forces Light Mode only
            darkModeSelector: 'none', 
        }
    }
});

// Register components globally for convenience
app.component('p-button', Button);
app.component('p-card', Card);
app.component('p-carousel', Carousel);
app.component('p-inputtext', InputText);
app.component('p-textarea', Textarea);
app.component('p-toolbar', Toolbar);
app.component('p-menubar', Menubar)

app.use(router);
app.mount('#app');